module.exports = __webpack_public_path__ + "img/p1.7260f9e0.png";